/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { useEffect } from "react";
import { environment } from "../../environment";
import ViewModel from "../../ViewModels/ViewModel";
import { useAppCoffeeMugContext } from "./../AppCoffeeMugContext";
import IAppCoffeeMugContext from "./../AppCoffeeMugContext/IAppCoffeeMugContext";
import AppCoffeeMugState from "./AppCoffeeMugState";

export default class AppCoffeeMugModel extends ViewModel<AppCoffeeMugState> {
    private readonly _appCoffeeMugContext: IAppCoffeeMugContext;

    public constructor() {
        super({
            initialState: {
                className: ClassNames.coffeeMugHidden,
                contentClassName: ClassNames.coffeeMugContentHidden,
                textClassName: ClassNames.coffeeMugContentTextHidden,
            },
        });
        this._appCoffeeMugContext = useAppCoffeeMugContext();
        useEffect(this.aktualisieren, [this.visible]);
    }

    public get visible(): boolean {
        return this._appCoffeeMugContext.visible && !environment.istBuchungsportal;
    }

    public get text(): string {
        return this._appCoffeeMugContext.text;
    }

    public get className(): string {
        return this.state.className;
    }

    public get contentClassName(): string {
        return this.state.contentClassName;
    }

    public get textClassName(): string {
        return this.state.textClassName;
    }

    private readonly aktualisieren = () => {
        if (this.visible) {
            this.eingabenBlockieren();
            const showMugTimeoutHandle = setTimeout(() => {
                this.einblenden();
            }, 1000);

            const showTextTimeoutHanlde = setTimeout(() => {
                this.einblendenMitText();
            }, 2000);

            return () => {
                clearTimeout(showMugTimeoutHandle);
                clearTimeout(showTextTimeoutHanlde);
            };
        }

        this.ausblenden();
        return () => {};
    };

    private eingabenBlockieren() {
        this.setState((nextState) => {
            nextState.className = ClassNames.coffeeMug;
            nextState.contentClassName = ClassNames.coffeeMugContentHidden;
            nextState.textClassName = ClassNames.coffeeMugContentTextHidden;
        });
    }

    private einblenden() {
        this.setState((nextState) => {
            nextState.className = ClassNames.coffeeMug;
            nextState.contentClassName = ClassNames.coffeeMugContent;
            nextState.textClassName = ClassNames.coffeeMugContentTextHidden;
        });
    }

    private einblendenMitText() {
        this.setState((nextState) => {
            nextState.className = ClassNames.coffeeMugBackdrop;
            nextState.contentClassName = ClassNames.coffeeMugContent;
            nextState.textClassName = ClassNames.coffeeMugContentText;
        });
    }

    private ausblenden() {
        this.setState((nextState) => {
            nextState.className = ClassNames.coffeeMugHidden;
            nextState.contentClassName = ClassNames.coffeeMugContentHidden;
            nextState.textClassName = ClassNames.coffeeMugContentTextHidden;
        });
    }
}

class ClassNames {
    static readonly coffeeMug: string = "lan-appcoffeemug";
    static readonly coffeeMugHidden: string = "lan-appcoffeemug lan-appcoffeemug--hidden";
    static readonly coffeeMugBackdrop: string = "lan-appcoffeemug lan-appcoffeemug--backdrop";
    static readonly coffeeMugContent: string = "lan-appcoffeemug__content";
    static readonly coffeeMugContentHidden: string = "lan-appcoffeemug__content lan-appcoffeemug__content--hidden";
    static readonly coffeeMugContentText: string = "lan-appcoffeemug__content__text";
    static readonly coffeeMugContentTextHidden: string = "lan-appcoffeemug__content__text lan-appcoffeemug__content__text--hidden";
}
